import type { AppState } from '../../store/types';
import type { AnyObject, ObjectWithId } from '../../types/common';

const EMPTY_MODAL_OPTIONS: AnyObject = {};
// A modal with no context items has to read back the same empty array every
// time, or every selector call would hand its subscriber a new reference.
const NO_CONTEXT_ITEMS: ObjectWithId[] = [];

export const getModalContextItems = (state: AppState, modalId: string) =>
  state.modalsManager[modalId]?.contextItems ?? NO_CONTEXT_ITEMS;

export const selectOptions = (state: AppState, modalId: string) =>
  state.modalsManager[modalId]?.options ?? EMPTY_MODAL_OPTIONS;

/**
 * The modal store holds every modal's context items and options in one untyped
 * bag, while each modal knows the shapes it was opened with. These read them as
 * those shapes.
 */
export const selectModalContextItems = <Item extends ObjectWithId>(
  state: AppState,
  modalId: string,
): Item[] =>
  // biome-ignore lint/plugin: see above.
  getModalContextItems(state, modalId) as Item[];

/** See selectModalContextItems. */
export const selectModalOptions = <Options extends object>(
  state: AppState,
  modalId: string,
): Options =>
  // biome-ignore lint/plugin: see selectModalContextItems.
  selectOptions(state, modalId) as Options;
